<template>
  <v-sheet
    class="bucket-card"
    :class="{
      'bucket-card--emphasize': emphasize,
      'bucket-card--compact': compact,
      'pa-4': !compact,
      'pa-3': compact,
    }"
    rounded="lg"
  >
    <div class="d-flex align-center justify-space-between mb-1">
      <div class="text-subtitle-2 font-weight-bold">{{ title }}</div>
      <v-chip
        v-if="netChange !== 0"
        :color="netChange > 0 ? 'success' : 'error'"
        size="x-small"
        variant="flat"
      >
        Net {{ netChange > 0 ? '+' : '' }}{{ netChange }}
      </v-chip>
    </div>
    <div class="text-caption text-grey mb-3">{{ subtitle }}</div>
    <div class="bucket-grid">
      <div class="bucket-cell">
        <div class="text-caption text-grey">Added</div>
        <div class="text-h6 font-weight-bold text-success">{{ bucket.added }}</div>
      </div>
      <div class="bucket-cell">
        <div class="text-caption text-grey">Removed</div>
        <div class="text-h6 font-weight-bold text-error">{{ bucket.removed }}</div>
      </div>
      <div class="bucket-cell">
        <div class="text-caption text-grey">Changed</div>
        <div class="text-h6 font-weight-bold">{{ bucket.changed }}</div>
      </div>
      <div class="bucket-cell">
        <div class="text-caption text-grey">Made Visible</div>
        <div class="text-h6 font-weight-bold">{{ bucket.listed }}</div>
      </div>
      <div class="bucket-cell">
        <div class="text-caption text-grey">Hidden</div>
        <div class="text-h6 font-weight-bold">{{ bucket.hidden }}</div>
      </div>
    </div>
  </v-sheet>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { InventoryChangesBucket } from '@/services/publishFlowService'

const props = withDefaults(
  defineProps<{
    title: string
    subtitle: string
    bucket: InventoryChangesBucket
    emphasize?: boolean
    compact?: boolean
  }>(),
  { emphasize: false, compact: false },
)

const netChange = computed(() => props.bucket.added - props.bucket.removed)
</script>

<style scoped>
.bucket-card {
  border: 1px solid #e5e7eb;
  background: #ffffff;
  height: 100%;
}

.bucket-card--emphasize {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.bucket-card--compact .bucket-grid {
  gap: 8px;
}

.bucket-card--compact .text-h6 {
  font-size: 1.1rem;
}

.bucket-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(72px, 1fr));
  gap: 12px;
}

.bucket-cell {
  min-width: 0;
}
</style>
